import React, {Component} from 'react';
import { Toggle } from '@carbon/react';
import * as midi from '../js/rpl_midi.js';

class LoggingToggle extends React.Component {

	constructor(props) {
		super(props);

		this.handleToggle = this.handleToggle.bind(this);

		this.state = {
			value: false,
			disabled: props.disabled
		};
	}

	render() {
	  	return <Toggle id="logging-toggle" labelText="Log to JavaScript Console" labelA="Off" labelB="On"
				toggled={this.state.value}
				disabled={this.state.disabled}
 				onToggle={this.handleToggle} />

	}

	handleToggle(newValue) {
		this.setState({value: newValue});

		midi.setLogging(newValue);
	}
}

export default LoggingToggle;
